/**
 * Atlas PM · 项目类型字典 · 数据 hooks（P4.5）
 *
 * 缓存 key 就地在模块内定义（不改 api/queryKeys.ts，保持文件边界自包含）。
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  projectTypeApi,
  type ProjectTypeCreateInput,
  type ProjectTypeUpdateInput,
} from './api';

const KEY = ['system', 'project-types'] as const;

export function useProjectTypes() {
  return useQuery({
    queryKey: KEY,
    queryFn: projectTypeApi.list,
  });
}

function useInvalidate() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: KEY });
}

export function useCreateProjectType() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (input: ProjectTypeCreateInput) => projectTypeApi.create(input),
    onSuccess: () => invalidate(),
  });
}

export function useUpdateProjectType() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: ProjectTypeUpdateInput }) =>
      projectTypeApi.update(id, input),
    onSuccess: () => invalidate(),
  });
}

export function useDeleteProjectType() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (id: string) => projectTypeApi.remove(id),
    onSuccess: () => invalidate(),
  });
}
